import { render } from "./TaskModalPriceTypeToggle.vue?vue&type=template&id=e33cc78a"
import script from "./TaskModalPriceTypeToggle.vue?vue&type=script&lang=js"
export * from "./TaskModalPriceTypeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__